import { ClassData } from "../../../common/dtos/classes.type";
import { convertTo12HourFormat } from "../../../common/utils/date.util";
import { openModal } from "../../../common/views/modal.view";
import { groupEventsByMonth, isMultipleDays, parseDate } from "../utils";

export async function setEventView(
  events: ClassData[],
  htmlComponent: string,
  useDescription: boolean = false
): Promise<void> {
  const htmlSection = $(htmlComponent);
  htmlSection.empty();

  if (!events.length) {
    htmlSection.append(`<div class="no-content">
      <h3>No upcoming dates published</h3>
      <div><p>Check back in a few days or call <a href="tel:9102950724" target="_blank">910-295-0724</a> for more info</p></div>
      </div>`);
    return;
  }
  const eventsByMonth = groupEventsByMonth(events);
  eventsByMonth.forEach((monthGroup) => {
    htmlSection.append(`<h4>${monthGroup.title}</h4>`);

    monthGroup.items.forEach((item: any) => {
      const categoryLocation = item?.location;

      const date = parseDate(item.start_date);
      const startTime = convertTo12HourFormat(item.start_time);
      const endTime = convertTo12HourFormat(item.end_time);
      let eventCardTemplate = "";
      if (isMultipleDays(item.meeting_days)) {
        const endDate = parseDate(item.end_date);
        eventCardTemplate = `
            <div class="event-card">
              <div class="multi-date">
                <div class="weekdays">
                  <span class="start">${date.weekday}</span>
                  <span class="and">-</span>
                  <span class="end">${endDate.weekday}</span>
                </div>
                <div class="day">
                  <span>${date.date}</span>
                  <span class="and">-</span>
                  <span>${endDate.date}</span>
                </div>
              </div>
              <div class="name">
                  <h3>${item.name}</h3>
                  <h5><span class="start-time">${startTime.time} ${
          startTime.period
        }</span> - <span class="end-time">${endTime.time} ${
          endTime.period
        }</span></h5>
                  <p>${
                    useDescription ? item.description : item.location_name
                  }</p>
              </div>
              <div>
                  <div class="price">
                      <div>$<span class="text">${item.tuition.fee}</span></div>
                  </div>
                  ${
                    item.openings.calculated_openings > 0
                      ? `
                    <button class="button enroll">
                      Enroll
                    </button>`
                      : `
                    <button class="button waitlist">Join Waitlist</button>
                    `
                  }
              </div>
            </div>
          `;
      } else {
        eventCardTemplate = `
        <div class="event-card">
          <div class="date">
            <span>
              ${date.weekday}
            </span>
            <span>
              ${date.date}
            </span>
          </div>
          <div class="name">
              <h3>${item.name}</h3>
              <h5><span class="start-time">${startTime.time} ${
          startTime.period
        }</span> - <span class="end-time">${endTime.time} ${
          endTime.period
        }</span></h5>
              <p>${item.location_name}</p>
          </div>
          <div>
              <div class="price">
                  <div>$<span class="text">${item.tuition.fee}</span></div>
              </div>
              ${
                item.openings.calculated_openings > 0
                  ? `<button class="button enroll">Enroll</button>`
                  : `<button class="button waitlist">Join Waitlist</button>`
              }
          </div>
        </div>
      `;
      }
      const $eventCard = $(eventCardTemplate);

      // Add event listener to the button
      $eventCard.find("button.enroll").on("click", (event) => {
        event.preventDefault();

        openModal({
          ...item,
          location: categoryLocation,
          category2: item.name,
        } as any);
      });

      $eventCard.find("button.waitlist").on("click", (event) => {
        event.preventDefault();

        openModal({
          ...item,
          location: categoryLocation,
          category2: item.name,
        } as any);
      });

      htmlSection.append($eventCard);
    });
  });
}
